import { GavValues, GavResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

export function calculateGav(values: GavValues, t?: ToolsTranslations['gav']): GavResult {
  const { purchases, feeMode } = values;
  if (!purchases || purchases.length === 0) return { totalCost: null, gav: null, isValid: false, message: t?.invalid.generic };

  let totalShares = 0;
  let totalCost = 0;

  for (const p of purchases) {
    const shares = Math.max(0, Number(p.shares) || 0);
    const pricePerShare = Math.max(0, Number(p.pricePerShare) || 0);
    const fee = feeMode === 'with' ? Math.max(0, Number(p.fee) || 0) : 0;
    totalShares += shares;
    totalCost += shares * pricePerShare + fee;
  }

  if (totalShares <= 0) return { totalCost: null, gav: null, isValid: false, message: t?.invalid.noShares };

  const gav = totalCost / totalShares;
  const roundedCost = Math.round(totalCost * 100) / 100;
  const roundedGav = Math.round(gav * 100) / 100;
  return { totalCost: roundedCost, gav: roundedGav, isValid: true };
}


